<template>
  <v-row justify="center" class="my-3">
    <v-btn x-large rounded outlined color="#000000" @click="onCancel" class="ma-2 btnCancel">Cancel</v-btn>
    <v-btn x-large rounded color="#ff0000" class="ma-2 btnContinue" @click=" gotoNextStep()">Continue</v-btn>
  </v-row>
</template>

<script>
export default {
name: "StepperFooter",
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    gotoNextStep() {
      this.$emit('finished');
    }
  }
}
</script>

<style scoped>

</style>
